import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

const UserProfilePage = lazyWithReload(() => import('src/pages/setting/user-profile'));

// Suspense wrapper with dynamic key for pathname
function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

// Layout wrapped in auth guard if needed
const getLayout = () =>
  CONFIG.auth.skip ? (
    <DashboardLayout>
      <SuspenseOutlet />
    </DashboardLayout>
  ) : (
    <AuthGuard>
      <DashboardLayout>
        <SuspenseOutlet />
      </DashboardLayout>
    </AuthGuard>
  );

export const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    element: getLayout(),
    children: [
      {
        index: true,
        element: <UserProfilePage />,
      },
    ],
  },
];
